type JsonLdProps = {
  data: unknown;
};

export function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: first-party JSON-LD via JSON.stringify
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
